import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";

import Logo from "../image/logo.png";
import SummarizeIcon from "@mui/icons-material/Summarize";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RefreshIcon from "@mui/icons-material/Refresh";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ListItemIcon from "@mui/material/ListItemIcon";
import Collapse from "@mui/material/Collapse";
import ListItemText from "@mui/material/ListItemText";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import WifiIcon from "@mui/icons-material/Wifi";
import TranslateIcon from "@mui/icons-material/Translate";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ListItemButton from "@mui/material/ListItemButton";
import InfoIcon from "@mui/icons-material/Info";
import BuildIcon from "@mui/icons-material/Build";
import MoreIcon from "@mui/icons-material/More";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import GroupIcon from "@mui/icons-material/Group";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ArticleIcon from "@mui/icons-material/Article";
import TableChartIcon from "@mui/icons-material/TableChart";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import LogoutIcon from "@mui/icons-material/Logout";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import BarChartIcon from "@mui/icons-material/BarChart";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import SchoolIcon from "@mui/icons-material/School";
import RateReviewIcon from "@mui/icons-material/RateReview";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import { useIdleTimer } from "react-idle-timer";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { NotificationList } from "../notification/Notification";
import MarkAttendanceModal from "../attendance/markAttendanceModal ";
import ResetPassword from "./resetPassword";
import { userDesignation } from "../../constants/masterUserConstants";
import SymbolCopyModal from "./symbolCopyModal";
import DucserialModal from "../dashboard/ducserialModal";
import { addloginEntryInAudit, logoutUser } from "../login/Login";
import HistoryIcon from "@mui/icons-material/History";
import TaskIcon from "@mui/icons-material/Task";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import { ExpandMoreSharp, ReportOutlined } from "@mui/icons-material";
import { clearLocalStorage } from "../../utils/localstorageClear";

import {
  Badge,
  Box,
  Grid,
  Icon,
  Menu,
  MenuItem,
  Modal,
  Popover,
  SwipeableDrawer,
  Tooltip,
  useMediaQuery,
} from "@mui/material";

export const drawerWidth = 210;

// Reusable sidebar nav item component
const SidebarNavItem = ({ icon, label, path, pathname, isMobile, onClick, indent = false, extra }) => {
  const isActive = path ? (path === pathname) : false;
  return (
    <ListItemButton
      selected={isActive}
      onClick={onClick}
      sx={indent ? { pl: 4 } : {}}
    >
      <ListItemIcon sx={{ minWidth: "36px", color: isActive ? '#0284c7' : '#64748b' }}>
        <Tooltip title={label} arrow placement="right">
          {icon}
        </Tooltip>
      </ListItemIcon>
      {!isMobile ? (
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: '0.85rem',
            fontWeight: isActive ? 600 : 500,
            color: isActive ? '#0f172a' : '#475569',
          }}
        />
      ) : (
        <Typography variant="p" component="div" align="left" style={{ fontSize: '14px', fontWeight: isActive ? 600 : 500 }}>
          {label}
        </Typography>
      )}
      {extra || null}
      {isActive && (
        <Box sx={{ position: 'absolute', left: 0, top: '20%', bottom: '20%', width: '4px', backgroundColor: '#0ea5e9', borderRadius: '0 4px 4px 0' }} />
      )}
    </ListItemButton>
  );
};

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: '100%',
  marginLeft: 0,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: '#ffffff',
  borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      marginTop: '70px',
      height: 'calc(100% - 70px)',
      backgroundColor: '#ffffff',
      borderRight: '1px solid rgba(226, 232, 240, 0.8)',
      boxShadow: '4px 0 10px -3px rgba(0, 0, 0, 0.07)',
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      marginTop: '70px',
      height: 'calc(100% - 70px)',
      backgroundColor: '#ffffff',
      borderRight: '1px solid rgba(226, 232, 240, 0.8)',
      boxShadow: '2px 0 8px -3px rgba(0, 0, 0, 0.05)',
    },
  }),
}));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '12px',
  backgroundColor: '#f8fafc',
  backdropFilter: 'none',
  '&:hover': {
    backgroundColor: '#ffffff',
    border: '1px solid rgba(59, 130, 246, 0.5)',
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
  border: '1px solid rgba(226, 232, 240, 0.8)',
  color: '#334155',
  display: 'flex',
  alignItems: 'center',
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#3b82f6',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.2, 1.2, 1.2, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '35ch',
    },
    fontSize: '0.875rem',
    fontWeight: 500,
    '&::placeholder': {
      color: '#64748b',
      opacity: 1,
    },
  },
}));

export default function Navbar(props) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const theme = useTheme();
  const open = props.open;
  const setOpen = props.setOpen;
  const [masterNested, setMasterNested] = React.useState(false);
  const [reportsNested, setReportsNested] = React.useState(false);
  const [paymentNested, setPaymentNested] = React.useState(false);
  const [MasterInOut, setMasterInOut] = React.useState(false);
  const [CommercialNested, setCommercialNested] = React.useState(false);
  const [intermediateProcedure, setIntermediateProcedure] =
    React.useState(false);
  const [notificationsNo, setNotificationsNo] = React.useState(0);
  const [resposiveAnchor, setResposiveAnchor] = React.useState({
    left: false,
  });

  const location = useLocation();
  const pathname = location.pathname;
  const routeSegments = pathname.split("/");
  let selectedRoute = routeSegments[1];
  if (routeSegments[1] === "master" && routeSegments.length > 1) {
    selectedRoute = routeSegments[2];
  }
  const convertToTitleCase = (str) => {
    return str
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const selectedRouteInUpperCase = convertToTitleCase(selectedRoute);
  // const selectedRouteInUpperCase = selectedRoute
  const [dropDown, setDropDown] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const designation = localStorage.getItem("designationIds")?.split(",") || [];
  let isOffLine = localStorage.getItem("isOffLine") == "true";

  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [popoverAnchor, setPopoverAnchor] = useState(null);

  const handleClickDesignation = (event) => {
    setPopoverAnchor(event.currentTarget);
  };

  const handlePopoverDesignationClosed = () => {
    setPopoverAnchor(null);
  };

  const handleDesignationSelect = (selectedId) => {
    const selectedDesignation = userDesignation.find(
      (designation) => designation.id === parseInt(selectedId)
    );
    if (selectedDesignation) {
      setSelectedDesignation(selectedDesignation.name);
      localStorage.setItem("designation", selectedDesignation.name);
      handlePopoverDesignationClosed();
    }
  };

  const storage_userName = localStorage.getItem("userName");
  const _UserID = localStorage.getItem("id");
  const storage_userType = localStorage.getItem("type");
  // Parse modules list into array of numbers
  const storage_modules = localStorage
    .getItem("modules")
    ?.split(",")
    .map((e) => Number(e));

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [userType, setUserType] = React.useState(localStorage.getItem("type"));
  const _clientId = localStorage.getItem("clientId");

  const handleOpenSearch = () => setSearchModalOpen(true);
  const handleCloseSearch = () => {
    setSearchModalOpen(false);
    setSearchTerm("");
  };


  const handleClickDropDown = (event) => {
    setDropDown(event.currentTarget);
  };

  const handleCloseDropDown = () => {
    setDropDown(null);
  };

  const handleButtonClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

const logout = async () => {
  try {
    // Call API logout first
    await logoutUser();

    const authToken = sessionStorage.getItem("authToken");

    // WAIT until audit log is saved
    await addloginEntryInAudit(
      "logout",
      _UserID,
      moment().format("YYYY-MM-DD HH:mm:ss"),
      authToken
    );

    props.setIsLoggedIn(false);
    clearLocalStorage();
    sessionStorage.clear();
    navigate("/");
    window.location.reload();

  } catch (error) {
    console.error("Error during logout:", error);
  }
};
  let previouspath = sessionStorage.getItem("currentPath");
const clearSearchFilterSessionStorage = (to) => {
  const shouldConfirmNavigation = [
    "/datasheet/edit",
    "/inward/editInward",
    "/master/masterEQP/editStandard",
    "/master/instrument/createInstrument",
    "/master/instrument/editInstrument",
    "/master/editStaticTable",
  ].some((route) => pathname.startsWith(route));
  if (shouldConfirmNavigation) {
    if (window.confirm("Are you sure you want to quit?")) {
      if (to !== previouspath) {
        sessionStorage.removeItem("searchBy");
        sessionStorage.removeItem("searchKey");
        sessionStorage.removeItem("searched");
        sessionStorage.removeItem("currentPath");
        sessionStorage.removeItem("ListPageCount");
        sessionStorage.removeItem("ListRowsPerPage");
        sessionStorage.removeItem("groupeSelectedFilters");
        sessionStorage.removeItem("selectedDisciplineIds");
        sessionStorage.removeItem("selectedLocation");
      }
      navigate(to);
      if (isMobile) {
        setResposiveAnchor(prev => ({ ...prev, left: false }));
      }
    }
  } else {
    if (to !== previouspath) {
      sessionStorage.removeItem("searchBy");
      sessionStorage.removeItem("searchKey");
      sessionStorage.removeItem("searched");
      sessionStorage.removeItem("currentPath");
      sessionStorage.removeItem("ListPageCount");
      sessionStorage.removeItem("ListRowsPerPage");
      sessionStorage.removeItem("groupeSelectedFilters");
      sessionStorage.removeItem("selectedDisciplineIds");
      sessionStorage.removeItem("selectedLocation");
    }
    navigate(to);
    if (isMobile) {
      setResposiveAnchor(prev => ({ ...prev, left: false }));
    }
  }
};
  const [isSymbolModalOpen, setIsSymbolModalOpen] = useState(false);
  const openSymbolModal = () => {
    setIsSymbolModalOpen(true);
  };
  const closeSymbolModal = () => {
    setIsSymbolModalOpen(false);
  };

  const hasAccessToModule = (key) => {
    key = Number(key);
    if (DISABLED_MODULE?.includes(key)) return false;
    if (`${storage_userType}` === "1") return true;
    else if (
      `${storage_userType}` === "2" ||
      `${storage_userType}` == "4" ||
      `${storage_userType}` == "3" ||
      `${storage_userType}` == "5" ||
      `${storage_userType}` == "6" ||
      `${storage_userType}` == "7" ||
      `${storage_userType}` == "8" 
    ) {
      if (storage_modules?.includes(key)) return true;
      else return false;
    } else {
      if ([1].includes(key)) return true;
      else return false;
    }
  };

const onIdle = async () => {
  await logout();
};

  const onActive = () => {};

  const onAction = () => {};

  // useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 15 * 60 * 1000,
  //   throttle: 250,
  //   crossTab: true,
  // });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open2 = Boolean(anchorEl);

  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open3 = Boolean(anchorEl2);

  const handleClick = (event) => {
    if (!anchorEl) setAnchorEl(event.currentTarget);
    else setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    if (props.rolesInfo.roles && props.rolesInfo.roles?.length > 1)
      setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const nav_modules = [
    // {
    //   type: "item",
    //   component: Link,
    //   path: "/dashboard",
    //   icon: <DashboardIcon />,
    //   name: storage_userType === "3" ? "Home" : "Dashboard",
    //   moduleId: "1",
    // },
    {
      type: "item",
      component: Link,
      icon: <FormatListBulletedIcon />,
      name: "Master",
      moduleId: "2",
      onClick: (e) => setMasterNested(!masterNested),
      extra: masterNested ? <ExpandLess /> : <ExpandMore />,
    },
  ];

  const toggleDrawer = (anchor, open) => (event) => {
    setResposiveAnchor({ ...resposiveAnchor, [anchor]: open });
  };
  const sidebarListItems = () => (
    <Box sx={{ overflowY: 'auto', overflowX: 'hidden', flex: 1, pb: '60px' }}>
    <List
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: "transparent",
        paddingTop: isMobile ? "24px" : "12px",
        '& .MuiListItemButton-root': {
          marginBottom: '2px',
          borderRadius: '10px',
          transition: 'background-color 0.15s ease',
          '& .MuiListItemText-primary, & .MuiTypography-root': {
            opacity: (!isMobile && !open) ? 0 : 1,
            transition: 'opacity 0.2s ease',
            whiteSpace: 'nowrap',
            fontSize: isMobile ? '14px !important' : '13.6px !important'
          },
          '& svg[data-testid="ExpandLessIcon"], & svg[data-testid="ExpandMoreIcon"]': {
            opacity: (!isMobile && !open) ? 0 : 1,
            transition: 'opacity 0.2s ease',
          },
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(224, 242, 254, 0.6)',
            '&:hover': {
              backgroundColor: 'rgba(224, 242, 254, 0.75)',
            }
          }
        }
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {hasAccessToModule("1") && !DISABLED_MODULE?.includes("Dashboard") && (
        <SidebarNavItem
          icon={<DashboardIcon />}
          label={storage_userType === "3" ? "Home" : "Dashboard"}
          path="/dashboard"
          pathname={pathname}
          isMobile={isMobile}
          onClick={() => clearSearchFilterSessionStorage("/dashboard")}
        />
      )}

      {/* Master parent toggle button (rendered via nav_modules map) */}
      {nav_modules.map((module) => {
        if (module.type === "item") {
          if (module.component)
            return (
              !isOffLine &&
              hasAccessToModule(module.moduleId) &&
              (module.to ? (
                <ListItemButton
                  component={module.component}
                  to={module.path}
                  onClick={module.onClick}
                  key={module.component}
                  selected={pathname.startsWith(module.path)}
                >
                  <ListItemIcon sx={{ minWidth: "36px", color: pathname.startsWith(module.path) ? '#0284c7' : '#64748b' }}>
                    <Tooltip title={module.name} arrow placement="right">
                      {module.icon}
                    </Tooltip>
                  </ListItemIcon>
                  {!isMobile ? (
                    <ListItemText
                      primary={module.name}
                      primaryTypographyProps={{
                        fontSize: '0.85rem',
                        fontWeight: pathname.startsWith(module.path) ? 600 : 500,
                        color: pathname.startsWith(module.path) ? '#0f172a' : '#475569'
                      }}
                    />
                  ) : (
                    <ListItemText>
                      <Typography variant="p" component="div" align="left"
                        style={{ fontSize: "14px", fontWeight: pathname.startsWith(module.path) ? 600 : 500 }}>
                        {module.name}
                      </Typography>
                    </ListItemText>
                  )}
                  {module.extra || ""}
                  {pathname.startsWith(module.path) && (
                    <Box sx={{ position: 'absolute', left: 0, top: '20%', bottom: '20%', width: '4px', backgroundColor: '#0ea5e9', borderRadius: '0 4px 4px 0' }} />
                  )}
                </ListItemButton>
              ) : (
                <ListItemButton onClick={module.onClick} key={module.component}>
                  <ListItemIcon sx={{ minWidth: "36px" }}>
                    <Tooltip title={module.name} arrow placement="right">
                      {module.icon}
                    </Tooltip>
                  </ListItemIcon>
                  {!isMobile ? (
                    <ListItemText primary={module.name} />
                  ) : (
                    <ListItemText>
                      <Typography variant="p" component="div" align="left" style={{ fontSize: "14px" }}>
                        {module.name}
                      </Typography>
                    </ListItemText>
                  )}
                  {module.extra || ""}
                </ListItemButton>
              ))
            );
        }
      })}

      {/* Master sub-menu */}
      {hasAccessToModule(2) && !DISABLED_MODULE?.includes("Master") && (
        <Collapse in={masterNested} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {hasAccessToModule(51) && !DISABLED_MODULE?.includes("Master EQP") && (
              <SidebarNavItem icon={<BuildIcon />} label="Master EQP" path="/master/masterEQP" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/masterEQP")} indent />
            )}
            {hasAccessToModule(52) && !DISABLED_MODULE?.includes("Instrument") && (
              <SidebarNavItem icon={<PrecisionManufacturingIcon />} label="Instrument" path="/master/instrument" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/instrument")} indent />
            )}
            {hasAccessToModule(53) && !DISABLED_MODULE?.includes("DUC Master") && (
              <SidebarNavItem icon={<AcUnitIcon />} label="DUC Master" path="/master/ducMasterList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/ducMasterList")} indent />
            )}
            {hasAccessToModule(63) && !DISABLED_MODULE?.includes("Assigned Duc") && (
              <SidebarNavItem icon={<AcUnitIcon />} label="Assigned Duc" path="/master/assignedDucList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/assignedDucList")} indent />
            )}
            {hasAccessToModule(64) && !DISABLED_MODULE?.includes("reservedSrf") && (
              <SidebarNavItem icon={<AcUnitIcon />} label="Reserved SRF" path="/master/reservedSRFTable" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/reservedSRFTable")} indent />
            )}
            {hasAccessToModule(54) && !DISABLED_MODULE?.includes("Discipline") && (
              <SidebarNavItem icon={<ArchitectureIcon />} label="Discipline" path="/master/discipline" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/discipline")} indent />
            )}
            {hasAccessToModule(55) && !DISABLED_MODULE?.includes("Remark") && (
              <SidebarNavItem icon={<MoreIcon />} label="Remark" path="/master/remark" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/remark")} indent />
            )}
            {hasAccessToModule(57) && !DISABLED_MODULE?.includes("Client") && (
              <SidebarNavItem icon={<GroupIcon />} label="Client" path="/master/client" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/client")} indent />
            )}
            {hasAccessToModule(58) && !DISABLED_MODULE?.includes("Units") && (
              <SidebarNavItem icon={<TableChartIcon />} label="Units" path="/master/unit/unitList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/unit/unitList")} indent />
            )}
            {hasAccessToModule(59) && !DISABLED_MODULE?.includes("Table Template") && (
              <SidebarNavItem icon={<TableChartIcon />} label="Table Template" path="/master/template" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/template")} indent />
            )}
            {hasAccessToModule(60) && !DISABLED_MODULE?.includes("Datasheet Template") && (
              <SidebarNavItem icon={<TableChartIcon />} label="Datasheet Template" path="/master/datasheetTemplate" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/datasheetTemplate")} indent />
            )}
            {hasAccessToModule(61) && !DISABLED_MODULE?.includes("Uncertainty") && (
              <SidebarNavItem icon={<TableChartIcon />} label="Uncertainty" path="/master/uncertinity/uncertinityList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/uncertinity/uncertinityList")} indent />
            )}
            {hasAccessToModule(62) && !DISABLED_MODULE?.includes("Settings") && (
              <SidebarNavItem icon={<TableChartIcon />} label="Settings" path="/master/setting" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/setting")} indent />
            )}
          </List>
        </Collapse>
      )}

      {/* ── Inward ── */}
      {hasAccessToModule(3) && !DISABLED_MODULE?.includes("Inward") && (
        <List component="div" disablePadding>
          <SidebarNavItem icon={<MoveToInboxIcon />} label="Inward" path="/inward" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/inward")} />
        </List>
      )}

      {/* ── Datasheets ── */}
      {hasAccessToModule("4") && !DISABLED_MODULE?.includes("Datasheets") && (
        <SidebarNavItem icon={<ArticleIcon />} label="Datasheets" path="/datasheet" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/datasheet")} />
      )}

      {/* ── Certificates ── */}
      {hasAccessToModule("5") && !DISABLED_MODULE?.includes("Certificates") && (
        <SidebarNavItem icon={<WorkspacePremiumIcon />} label="Certificates" path="/certificate" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/certificate")} />
      )}

      {/* ── Courier Register ── */}
      {!isOffLine && hasAccessToModule("7") && !DISABLED_MODULE?.includes("Courier Register") && (
        <SidebarNavItem icon={<MailOutlineIcon />} label="Courier Register" path="/courier/courierList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/courier/courierList")} />
      )}

      {/* ── Expenses ── */}
      {!isOffLine && hasAccessToModule("8") && !DISABLED_MODULE?.includes("Expenses") && (
        <SidebarNavItem icon={<ReceiptIcon />} label="Expenses" path="/master/expense" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/expense")} />
      )}

      {/* ── Scheduler ── */}
      {!isOffLine && hasAccessToModule("12") && !DISABLED_MODULE?.includes("Scheduler") && (
        <SidebarNavItem icon={<CalendarMonthIcon />} label="Scheduler" path="/scheduler" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/scheduler")} />
      )}

      {/* ── External Calibration ── */}
      {!isOffLine && hasAccessToModule("13") && !DISABLED_MODULE?.includes("External Calibration") && (
        <SidebarNavItem icon={<OpenInNewIcon />} label="External Calibration" path="/externalCalibrationList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/externalCalibrationList")} />
      )}

      {/* Reports (parent toggle) */}
      {!isOffLine && hasAccessToModule("35") && !DISABLED_MODULE?.includes("Reports") && (
        <ListItemButton
          // component={Link}
          // to="/masterEQPInOutList"
          onClick={(e) => setReportsNested(!reportsNested)}
        >
          <ListItemIcon sx={{ minWidth: "36px" }}>
            <Tooltip title="Reports" arrow placement="right">
              <BarChartIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText primary={"Reports"} />
          ) : (
            <ListItemText>
              <Typography variant="p" component="div" align="left" style={{ fontSize: "14px" }}>{"Reports"}</Typography>
            </ListItemText>
          )}
          {reportsNested ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={reportsNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule("151") && !DISABLED_MODULE?.includes("Summary Report") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Summary Report" path="/summaryReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/summaryReport")} indent />
          )}
          {hasAccessToModule("152") && !DISABLED_MODULE?.includes("History Card") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="History Card" path="/historyCard" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/historyCard")} indent />
          )}
          {hasAccessToModule("153") && !DISABLED_MODULE?.includes("Work Report") && (
            <SidebarNavItem icon={<ReceiptIcon />} label="Work Report" path="/workReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/workReport")} indent />
          )}
          {hasAccessToModule("154") && !DISABLED_MODULE?.includes("WCR Report") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="WCR Report" path="/wcrReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/wcrReport")} indent />
          )}
          {hasAccessToModule("155") && !DISABLED_MODULE?.includes("Department Analytics") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Dept Analytics" path="/deptAnalyticsReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/deptAnalyticsReport")} indent />
          )}
          {hasAccessToModule("156") && !DISABLED_MODULE?.includes("Inward Register") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Inward Register" path="/inwardregister" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/inwardregister")} indent />
          )}
          {hasAccessToModule("157") && !DISABLED_MODULE?.includes("Progress report") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Progress report" path="/progressreport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/progressreport")} indent />
          )}
          {hasAccessToModule("158") && !DISABLED_MODULE?.includes("SRF_ULR_Register") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="SRF_ULR_Register" path="/srfUlrRegisterList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/srfUlrRegisterList")} indent />
          )}
          {hasAccessToModule("159") && !DISABLED_MODULE?.includes("Master Uses") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Master Uses" path="/masteruses" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/masteruses")} indent />
          )}
          {hasAccessToModule("160") && !DISABLED_MODULE?.includes("Approval Status") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Approval Status" path="/approvalStatusReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/approvalStatusReport")} indent />
          )}
          {hasAccessToModule("1601") && !DISABLED_MODULE?.includes("ReCalibration Report") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="ReCalibration Report" path="/reCalibrationReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/reCalibrationReport")} indent />
          )}
        </List>
      </Collapse>

      {/* Commercial (parent toggle) */}
      {!isOffLine && hasAccessToModule("14") && !DISABLED_MODULE?.includes("Commercial") && (
        <ListItemButton onClick={(e) => setCommercialNested(!CommercialNested)}>
          <ListItemIcon sx={{ minWidth: "36px" }}>
            <Tooltip title="Commercial" arrow placement="right">
              <BusinessCenterIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText primary={"Commercial"} />
          ) : (
            <ListItemText>
              <Typography variant="p" component="div" align="left" style={{ fontSize: "14px" }}>{"Commercial"}</Typography>
            </ListItemText>
          )}
          {CommercialNested ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={CommercialNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {hasAccessToModule(111) && !DISABLED_MODULE?.includes("Enquiry") && (
            <SidebarNavItem icon={<NewspaperIcon />} label="Enquiry" path="/master/enquiry/enquiryList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/enquiry/enquiryList")} indent />
          )}
          {hasAccessToModule(112) && !DISABLED_MODULE?.includes("Enquiry Followup") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Enquiry Followup" path="/enquiry/followUpReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/enquiry/followUpReport")} indent />
          )}
          {hasAccessToModule(113) && !DISABLED_MODULE?.includes("Price List") && (
            <SidebarNavItem icon={<ArchitectureIcon />} label="Price List" path="/master/product" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/product")} indent />
          )}
          {hasAccessToModule(114) && !DISABLED_MODULE?.includes("Quotation") && (
            <SidebarNavItem icon={<RequestQuoteIcon />} label="Quotation" path="/quotation" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/quotation")} indent />
          )}
          {hasAccessToModule(115) && !DISABLED_MODULE?.includes("poAcceptance") && (
            <SidebarNavItem icon={<PodcastsIcon />} label="poAcceptance" path="/poAcceptance" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/poAcceptance")} indent />
          )}
          {hasAccessToModule(116) && !DISABLED_MODULE?.includes("Invoice") && (
            <SidebarNavItem icon={<ReceiptIcon />} label="Invoice" path="/viewInvoice" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/viewInvoice")} indent />
          )}
          {hasAccessToModule(117) && !DISABLED_MODULE?.includes("Supplier Invoice") && (
            <SidebarNavItem icon={<ReceiptIcon />} label="Supplier Invoice" path="/supplierInvoiceslist" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/supplierInvoiceslist")} indent />
          )}
        </List>
      </Collapse>

      {/* Payment (parent toggle) */}
      {!isOffLine && hasAccessToModule("17") && !DISABLED_MODULE?.includes("Payment") && (
        <ListItemButton onClick={(e) => setPaymentNested(!paymentNested)}>
          <ListItemIcon sx={{ minWidth: "36px" }}>
            <Tooltip title="Payment" arrow placement="right">
              <CreditCardIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText primary={"Payment"} />
          ) : (
            <ListItemText>
              <Typography variant="p" component="div" align="left" style={{ fontSize: "14px" }}>{"Payment"}</Typography>
            </ListItemText>
          )}
          {paymentNested ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={paymentNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {!isOffLine && hasAccessToModule("161") && (
            <SidebarNavItem icon={<BuildIcon />} label="Payment History" path="/paymentMaster" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/paymentMaster")} indent />
          )}
          {!isOffLine && hasAccessToModule("162") && (
            <SidebarNavItem icon={<PrecisionManufacturingIcon />} label="Account Statement" path="/accountStatement" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/accountStatement")} indent />
          )}
          {!isOffLine && hasAccessToModule("163") && (
            <SidebarNavItem icon={<PrecisionManufacturingIcon />} label="Gst Report" path="/gstReport" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/gstReport")} indent />
          )}
        </List>
      </Collapse>

      {/* Master In/Out (parent toggle) */}
      {!isOffLine && hasAccessToModule("21") && !DISABLED_MODULE?.includes("Master In/Out") && (
        <ListItemButton
          // component={Link}
          // to="/masterEQPInOutList"
          onClick={(e) => setMasterInOut(!MasterInOut)}
        >
          <ListItemIcon sx={{ minWidth: "36px" }}>
            <Tooltip title="Payment" arrow placement="right">
              <SwapHorizIcon />
            </Tooltip>
          </ListItemIcon>
          {!isMobile ? (
            <ListItemText primary={"Master In/Out"} />
          ) : (
            <ListItemText>
              <Typography variant="p" component="div" align="left" style={{ fontSize: "14px" }}>{"Master In/Out"}</Typography>
            </ListItemText>
          )}
          {MasterInOut ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      )}
      <Collapse in={MasterInOut} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {!isOffLine && hasAccessToModule("173") && (
            <SidebarNavItem icon={<ReceiptIcon />} label="Gate Pass" path="/challanList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/challanList")} indent />
          )}
          {!isOffLine && hasAccessToModule("171") && (
            <SidebarNavItem icon={<ReceiptIcon />} label="Master Assign" path="/masterEQPInOutList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/masterEQPInOutList")} indent />
          )}
          {!isOffLine && hasAccessToModule("172") && (
            <SidebarNavItem icon={<BookmarkIcon />} label="Assign Report" path="/inOutReportList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/inOutReportList")} indent />
          )}
        </List>
      </Collapse>

      {/* Independent Due  */}
      {!isOffLine && hasAccessToModule("36") && !DISABLED_MODULE?.includes("Independent Due") && (
        <SidebarNavItem icon={<HistoryIcon />} label="Independent Due" path="/independentDue" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/independentDue")} />
      )}

      {/*Task Management*/}
      {!isOffLine && hasAccessToModule("37") && !DISABLED_MODULE?.includes("Task Management") && (
        <SidebarNavItem icon={<TaskIcon />} label="Task Management" path="/taskMgmtList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/taskMgmtList")} />
      )}

      {/* Client Complaints  */}
      {!isOffLine && hasAccessToModule("28") && !DISABLED_MODULE?.includes("Client Complaints") && (
        <SidebarNavItem icon={<ReportProblemIcon />} label="Client Complaints" path="/complaintsList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/complaintsList")} />
      )}

      {/* Training Resources */}
      {!isOffLine && !DISABLED_MODULE?.includes("Training Resources") && (
        <SidebarNavItem icon={<SchoolIcon />} label="Training Resources" path="/trainingresources" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/trainingresources")} />
      )}

      {/* Client Feedback */}
      {!isOffLine && hasAccessToModule("29") && !DISABLED_MODULE?.includes("Client Feedback") && (
        <SidebarNavItem icon={<RateReviewIcon />} label="Client Feedback" path="/feedbackList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/feedbackList")} />
      )}

      {/* User Management */}
      {!isOffLine && hasAccessToModule("25") &&
        // `${storage_userType}` === "1" &&
        !DISABLED_MODULE?.includes("User") && (
          <SidebarNavItem icon={<ManageAccountsIcon />} label="User" path="/master/users/userList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/users/userList")} />
        )}

      {/*  Audit Log  */}
      {!isOffLine && hasAccessToModule("27") &&
        // `${storage_userType}` === "1" &&
        !DISABLED_MODULE?.includes("Audit") && (
          <SidebarNavItem icon={<SummarizeIcon />} label="Audit" path="/audit" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/audit")} />
        )}

      {/*  Request Form  */}
      {!isOffLine && hasAccessToModule("30") && !DISABLED_MODULE?.includes("Request Form") && (
        <SidebarNavItem icon={<ArticleIcon />} label="Request Form" path="/requestFormList" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/requestFormList")} />
      )}

      {/*  Document Upload  */}
      {!isOffLine && hasAccessToModule("31") && !DISABLED_MODULE?.includes("Document Upload") && (
        <SidebarNavItem icon={<ArticleIcon />} label="Document Upload" path="/documentUpload" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/documentUpload")} />
      )}

      {/*  Attendance  */}
      {!isOffLine && hasAccessToModule("33") &&
        // `${storage_userType}` === "1" &&
        !DISABLED_MODULE?.includes("Attendance") && (
          <SidebarNavItem icon={<DocumentScannerIcon />} label="Attendance" path="/attendance" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/attendance")} />
        )}

      {/*   Help   */}
      {!isOffLine && hasAccessToModule("32") &&
        // `${storage_userType}` === "1" &&
        !DISABLED_MODULE?.includes("Help") && (
          <SidebarNavItem icon={<LiveHelpIcon />} label="Help" path="/help" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/help")} />
        )}

      <Collapse in={intermediateProcedure} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarNavItem icon={<BuildIcon />} label="Intermediate Procedure" path="/master/intermediateProcedure" pathname={pathname} isMobile={isMobile} onClick={() => clearSearchFilterSessionStorage("/master/intermediateProcedure")} indent />
          <ListItemButton
            sx={{ pl: 4 }}
            component={Link}
            to="/master/checkRecords"
            onClick={clearSearchFilterSessionStorage}
          >
            <ListItemIcon sx={{ minWidth: "36px" }}>
              <Tooltip title="Check Records" arrow placement="right">
                <PrecisionManufacturingIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Check Records" />
          </ListItemButton>
        </List>
      </Collapse>

      {/*  Mobile-view user info  */}
      {isMobile && (
        <>
          <Divider sx={{ backgroundColor: "rgba(0, 0, 0, 0.12)", height: "1px", margin: '8px 16px' }} />
          <ListItemButton sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}>
            <ListItemIcon sx={{ minWidth: "36px", color: '#64748b' }}>
              <Tooltip title="Notification" arrow placement="right">
                <AccountCircleIcon />
              </Tooltip>
            </ListItemIcon>
            <Tooltip title="User (User Type)" style={{ textTransform: "uppercase" }}>
              <ListItemText
                primary={`${storage_userName} (${["admin","Engineer","Client","Branch Admin","Lab Co-Ordinator","Account Dept","Sales Dept","Site InCharge"][Number(storage_userType) - 1]})`}
                primaryTypographyProps={{ fontWeight: 500, color: '#475569', textTransform: 'uppercase' }}
              />
            </Tooltip>
          </ListItemButton>
          {/* Mobile Role Dropdown */}
          {props.rolesInfo.roles?.length ? (
            <SidebarNavItem
              icon={<ManageAccountsIcon />}
              label={props.rolesInfo.currentRole?.name || "Select Role"}
              isMobile={isMobile}
              onClick={handleClick2}
              extra={props.rolesInfo.roles?.length > 1 ? (
                <ExpandMoreSharp sx={{ 
                  transition: 'transform 0.3s', 
                  transform: open3 ? 'rotate(180deg)' : 'rotate(0deg)',
                  fontSize: '1.2rem',
                }} />
              ) : null}
            />
          ) : (
            ""
          )}
          {!isOffLine && hasAccessToModule("34") && !DISABLED_MODULE?.includes("MarkAttendance") && (
            <MarkAttendanceModal isMobile={isMobile} />
          )}
          {!DISABLED_MODULE?.includes("HistoricalMode") && (
            <ListItemButton
              sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}
              onClick={() => {
                const currentState = JSON.parse(sessionStorage.getItem("historicalTable"));
                const newState = !currentState;
                sessionStorage.setItem("historicalTable", JSON.stringify(newState));
                window.location.reload();
              }}
            >
              <ListItemIcon sx={{ minWidth: "36px", color: '#64748b' }}>
                {JSON.parse(sessionStorage.getItem("historicalTable")) ? <DataUsageIcon /> : <HistoryIcon />}
              </ListItemIcon>
              <ListItemText primary="Historical Mode" primaryTypographyProps={{ fontWeight: 500, color: '#475569' }} />
            </ListItemButton>
          )}
          {!DISABLED_MODULE?.includes("OfflineMode") && (
            <ListItemButton
              sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}
              onClick={() => {
                isOffLine = !isOffLine;
                localStorage.setItem("isOffLine", isOffLine.toString());
                window.location.reload();
              }}
            >
              <ListItemIcon sx={{ minWidth: "36px", color: '#64748b' }}>
                {!isOffLine ? <WifiOffIcon /> : <WifiIcon />}
              </ListItemIcon>
              <ListItemText primary={isOffLine ? "Online" : "Offline"} primaryTypographyProps={{ fontWeight: 500, color: '#475569' }} />
            </ListItemButton>
          )}
          {!isOffLine && <ResetPassword isMobile={isMobile} />}
          <ListItemButton sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }} onClick={logout}>
            <ListItemIcon sx={{ minWidth: "36px", color: '#64748b' }}>
              <Tooltip title="Logout" arrow placement="right">
                <LogoutIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Logout" primaryTypographyProps={{ fontWeight: 500, color: '#475569' }} />
          </ListItemButton>
          <ListItemButton sx={{ '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}>
            <ListItemIcon sx={{ minWidth: "36px", color: '#64748b' }}>
              <Tooltip title="info" arrow placement="right">
                <InfoIcon />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569', letterSpacing: '0.02rem' }}>LABCITY SOFTWARE</Typography>
                  <Typography sx={{ fontSize: '0.7rem', color: '#94a3b8', mt: -0.2, fontWeight: 500 }}>Build v3.0.0</Typography>
                </Box>
              }
            />
          </ListItemButton>
        </>
      )}
    </List>
    </Box>
  );
  const MobileList = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250, display: "flex", flexDirection: "column", height: "100%" }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <DrawerHeader>
        <Typography variant="h6" gutterBottom component="div">
          Calibration
        </Typography>
        <IconButton onClick={toggleDrawer(anchor, false)}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </DrawerHeader>
      {sidebarListItems()}
    </Box>
  );

  const handleDrawerToggle = () => {
    if (isMobile) {
      setResposiveAnchor({ ...resposiveAnchor, left: !resposiveAnchor.left });
    } else {
      // handleDrawerOpen();
      setOpen(!open);
    }
  };

  React.useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  return (
    <>
      {/* <CssBaseline /> */}
      <AppBar position="fixed" open={open} color="default" sx={{ backgroundColor: '#fff', color: '#333', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar
          variant="dense"
          style={{ paddingRight: "5px", minHeight: "70px", justifyContent: 'space-between' }}
        >
          {/* Left Side: Logo & Roles */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* Mobile hamburger button */}
          {isMobile && (
            <IconButton
              onClick={() => setResposiveAnchor({ ...resposiveAnchor, left: !resposiveAnchor.left })}
              sx={{ mr: 1, backgroundColor: 'rgba(255,255,255,0.6)', border: '1px solid rgba(186,230,253,0.4)', borderRadius: '10px' }}
              size="small"
            >
              <MenuIcon sx={{ fontSize: '1.2rem', color: '#334155' }} />
            </IconButton>
          )}
            {!isMobile && (
              <Box
                onClick={() => navigate("/dashboard")}
                sx={{
                  height: "44px",
                  maxWidth: "160px",
                  minWidth: "44px",
                  marginRight: "20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  src={`${Logo}`}
                  alt="logo"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    objectPosition: "left center",
                  }}
                />
              </Box>
            )}
            
            {/* Role Dropdown */}
            {!isMobile && (
              <Tooltip title="Role">
                  <span>
                    {props.rolesInfo.roles?.length ? (
                      <Button
                        onClick={handleClick2}
                        size="small"
                        aria-controls={open2 ? "Role" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open2 ? "true" : undefined}
                        endIcon={<ExpandMoreSharp sx={{ 
                          transition: 'transform 0.3s', 
                          transform: open3 ? 'rotate(180deg)' : 'rotate(0deg)' 
                        }} />}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.6)', 
                            backdropFilter: 'blur(xl)',
                            color: '#334155',
                            borderRadius: '10px',
                            padding: '6px 16px',
                            marginLeft: '10px',
                            textTransform: 'uppercase',
                            fontWeight: 700,
                            fontSize: '0.8125rem',
                            letterSpacing: '0.025em',
                            border: '1px solid rgba(186, 230, 253, 0.4)',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' }
                        }}
                        disabled={
                          !props.rolesInfo.roles ||
                          props.rolesInfo.roles?.length === 1
                        }
                      >
                        {props.rolesInfo.currentRole?.name || "Select Role"}
                      </Button>
                    ) : (
                      ""
                    )}
                  </span>
                </Tooltip>
            )}
          </Box>

          {/* Center Search Bar */}
          <Search sx={{
                            display: { xs: 'none', md: 'flex' },
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#fcffff', 
                            borderRadius: '20px',
                            width: { md: '200px', lg: '300px' },
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            '&:hover': { backgroundColor: '#fcffff' }
                        }}>
            <SearchIconWrapper>
              <DocumentScannerIcon sx={{ fontSize: '1.1rem', opacity: 0.8 }} />
            </SearchIconWrapper>
            
            <StyledInputBase
              placeholder="Search DUCID or Serial No."
              inputProps={{ 'aria-label': 'search' }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOpenSearch();
                }
              }}
            />
            <IconButton
              onClick={() => {
                handleOpenSearch();
              }}
              sx={{ p: '10px', paddingRight: '10px'  }}
            >
              <SearchIcon color="primary" />
            </IconButton>
          </Search>

          {/* Right Side: Icons & Admin */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Refresh">
            <IconButton
              onClick={() => {
                if ("serviceWorker" in navigator) {
                  navigator.serviceWorker.ready.then((registration) => {
                    registration.active.postMessage("clear-cache");
                    window.location.reload(true);
                  });
                }
                window.location.href = `${
                  window.location.pathname
                }?${new Date().getTime()}`;
                window.location.reload(true);
              }}
              size="small"
              sx={{ ml: 1, height: "35px", width: "35px" }}
              style={{ backgroundColor: "white" }}
            >
              <RefreshIcon style={{ color: "#1976d2" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Notification">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 1, height: "35px", width: "35px" }}
              aria-controls={open2 ? "available-roles" : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? "true" : undefined}
              style={{ backgroundColor: "white" }}
            >
              <Badge color="secondary" badgeContent={`${notificationsNo}`}>
                <NotificationsNoneIcon style={{ color: "#1976d2" }} />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip
            style={{
              textTransform: "uppercase",
              display: "flex",
              gap: "0px",
              alignItems: "center",
            }}
            title="Symbol"
          >
            <IconButton
              size="small"
              sx={{ ml: 1, height: "35px", width: "35px" }}
              style={{ backgroundColor: "white" }}
              onClick={openSymbolModal}
            >
              <TranslateIcon style={{ color: "#1976d2", fontSize: "1.2rem" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            style={{
              textTransform: "uppercase",
              display: "flex",
              gap: "0px",
              alignItems: "center",
            }}
            title={
              JSON.parse(sessionStorage.getItem("historicalTable"))
                ? `Show Current Data`
                : `Show Historical Data`
            }
          >
            <span>
              <IconButton
                size="small"
                sx={{ ml: 1, height: "35px", width: "35px" }}
                style={{ backgroundColor: "white" }}
                onClick={() => {
                  const currentState = JSON.parse(
                    sessionStorage.getItem("historicalTable")
                  );
                  const newState = !currentState;
                  sessionStorage.setItem(
                    "historicalTable",
                    JSON.stringify(newState)
                  );
                  window.location.reload();
                }}
              >
                {JSON.parse(sessionStorage.getItem("historicalTable")) ? (
                  <DataUsageIcon
                    style={{ color: "#1976d2", fontSize: "1.2rem" }}
                  />
                ) : (
                  <HistoryIcon
                    style={{ color: "#1976d2", fontSize: "1.2rem" }}
                  />
                )}
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip
            style={{
              textTransform: "uppercase",
              display: "flex",
              gap: "0px",
              alignItems: "center",
            }}
            title="Online"
          >
            <span>
              <IconButton
                size="small"
                sx={{ ml: 1, height: "35px", width: "35px" }}
                style={{ backgroundColor: "white" }}
                disabled
              >
                {isOffLine ? (
                  <WifiOffIcon
                    style={{ color: "#1976d2", fontSize: "1.2rem" }}
                  />
                ) : (
                  <WifiIcon style={{ color: "#1976d2", fontSize: "1.2rem" }} />
                )}
              </IconButton>
            </span>
          </Tooltip>

          {!isMobile && (
              <Tooltip
                style={{
                  display: "flex",
                  gap: "0px",
                  alignItems: "center",
                }}
                onClick={handleClickDropDown}
                title="Profile"
              >
                  <Button
                    onClick={handleClickDropDown}
                    endIcon={<ExpandMoreSharp sx={{ 
                          transition: 'transform 0.3s', 
                          transform: Boolean(dropDown) ? 'rotate(180deg)' : 'rotate(0deg)' 
                        }} />}
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.6)', 
                      backdropFilter: 'blur(xl)',
                      color: '#334155',
                      borderRadius: '10px',
                      padding: '6px 16px',
                      marginLeft: '20px',
                      marginRight: '10px',
                      textTransform: 'uppercase',
                      fontWeight: 700,
                      fontSize: '0.8125rem',
                      letterSpacing: '0.025em',
                      border: '1px solid rgba(186, 230, 253, 0.4)',
                      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' }
                    }}
                  >
                    {storage_userName} ({
                      [
                        "ADMIN",
                        "ENGINEER",
                        "CLIENT",
                        "BRANCH ADMIN",
                        "LAB CO-ORDINATOR",
                        "ACCOUNT DEPT",
                        "SALES DEPT",
                        "SITE INCHARGE",
                      ][Number(storage_userType) - 1]
                    })
                  </Button>
              </Tooltip>
          )}
          </Box>
          <Popover
            open={Boolean(dropDown)}
            anchorEl={dropDown}
            onClose={handleCloseDropDown}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            TransitionProps={{ timeout: 120 }}
            PaperProps={{
              sx: {
                overflow: "hidden",
                backdropFilter: "blur(24px)",
                backgroundColor: "rgba(255,255,255,0.70)",
                border: "1px solid rgba(186,230,253,0.40)",
                borderRadius: "12px",
                boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
                minWidth: "224px",
              }
            }}
          >
            <div style={{ padding: "6px 0px" }}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                    {/* <Button onClick={logout}>
                    <LibraryAddCheckIcon style={{ marginRight: "10px" }} />
                    Mark Attendance
                  </Button> */}
                  {!isOffLine &&
                    hasAccessToModule("34") &&
                    !DISABLED_MODULE?.includes("MarkAttendance") && (
                      <MarkAttendanceModal isMobile={isMobile} />
                    )}
                </Grid>
                {!isMobile && !DISABLED_MODULE?.includes("OfflineMode") && (
                  <Grid item>
                    <Button
                      onClick={() => {
                        isOffLine = !isOffLine;
                        localStorage.setItem("isOffLine", isOffLine.toString());
                        window.location.reload();
                      }}
                      sx={{ 
                        justifyContent: 'flex-start',
                        gap: '12px',
                        px: '16px',
                        py: '9px',
                        borderBottom: '1px solid rgba(203,213,225,0.20)',
                        width: '100%',
                        color: '#334155',
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        fontSize: '0.8125rem',
                        letterSpacing: '0.025em',
                        '&:hover': { backgroundColor: 'rgba(14,165,233,0.08)' }
                      }}
                    >
                      {!isOffLine ? (
                        <WifiOffIcon sx={{ color: '#1e40af', fontSize: '1.1rem' }} />
                      ) : (
                        <WifiIcon sx={{ color: '#1e40af', fontSize: '1.1rem' }} />
                      )}
                      {isOffLine ? "ONLINE" : "OFFLINE"}
                    </Button>
                  </Grid>
                )}
                {!isMobile && !isOffLine && (
                  <Grid item>
                    <ResetPassword isMobile={isMobile} />
                  </Grid>
                )}
                {!isMobile && (
                  <Grid item>
                    <Button onClick={logout} sx={{ 
                      justifyContent: 'flex-start',
                      gap: '12px',
                      px: '16px',
                      py: '9px',
                      borderBottom: '1px solid rgba(203,213,225,0.20)',
                      width: '100%',
                      color: '#334155',
                      textTransform: 'uppercase',
                      fontWeight: 700,
                      fontSize: '0.8125rem',
                      letterSpacing: '0.025em',
                      '&:hover': { backgroundColor: 'rgba(14,165,233,0.08)' }
                    }}>
                      <LogoutIcon sx={{ color: '#dc2626', fontSize: '1.1rem' }} />
                      LOGOUT
                    </Button>
                  </Grid>
                )}
                {!isMobile && (
                  <Grid item>
                    <Button onClick={handleButtonClick} sx={{ 
                      justifyContent: 'flex-start',
                      gap: '12px',
                      px: '16px',
                      py: '9px',
                      width: '100%',
                      color: '#334155',
                      textTransform: 'uppercase',
                      fontWeight: 700,
                      fontSize: '0.8125rem',
                      letterSpacing: '0.025em',
                      '&:hover': { backgroundColor: 'rgba(14,165,233,0.08)' }
                    }}>
                      <InfoIcon sx={{ color: '#1e40af', fontSize: '1.1rem' }} />
                      INFO
                    </Button>
                  </Grid>
                )}
              </Grid>
            </div>
          </Popover>

          <Modal
            open={isModalOpen}
            onClose={handleCloseModal}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "100%",
            }}
          >
            <div
              style={{
                height: "24px",
                backgroundColor: "#fff",
                position: "fixed",
                top: "7%",
                right: "0px",
                width: "auto",
                textAlign: "right",
                boxSizing: "border-box",
                color: "#fff",
              }}
            >
              <span
                style={{
                  backgroundColor: "#000",
                  padding: "3px",
                }}
              >
                LABCITY Software version 3.0.0
              </span>
            </div>
          </Modal>
        </Toolbar>
      </AppBar>

      {!isMobile ? (
        <Drawer variant="permanent" open={open}>
          <DrawerHeader sx={{ minHeight: "60px !important", borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: open ? 'flex-end' : 'center', px: 1 }}>
            <IconButton onClick={handleDrawerToggle} sx={{ 
              backgroundColor: 'rgba(255,255,255,0.4)', 
              backdropFilter: 'blur(md)',
              border: '1px solid rgba(255,255,255,0.3)',
              boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.6)' }
            }}>
              <MenuIcon sx={{ fontSize: '1.2rem', color: '#334155' }} />
            </IconButton>
          </DrawerHeader>
          {sidebarListItems()}
        </Drawer>
      ) : null}

      <SwipeableDrawer
        anchor={"left"}
        open={resposiveAnchor["left"]}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {MobileList("left")}
      </SwipeableDrawer>

      <NotificationList
        anchorEl={anchorEl}
        open={open2}
        close={handleClose}
        notifyNumber={(n) => setNotificationsNo(n)}
        isMobile={isMobile}
      />
      <Menu
        anchorEl={anchorEl2}
        id="available-roles"
        open={open3}
        onClose={handleClose2}
        onClick={handleClose2}
        TransitionProps={{ timeout: 120 }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "hidden",
              backdropFilter: "blur(24px)",
              backgroundColor: "rgba(255,255,255,0.70)",
              border: "1px solid rgba(186,230,253,0.40)",
              borderRadius: "12px",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
              mt: 1.5,
              minWidth: "224px",
              "& .MuiMenuItem-root": {
                padding: "10px 16px",
                borderBottom: "1px solid rgba(203,213,225,0.20)",
              },
              "& .MuiMenuItem-root:last-of-type": {
                borderBottom: "none",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "rgba(14,165,233,0.08)",
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 14,
                width: 10,
                height: 10,
                bgcolor: "rgba(255,255,255,0.70)",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
                borderTop: "1px solid rgba(186,230,253,0.40)",
                borderLeft: "1px solid rgba(186,230,253,0.40)",
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {(props.rolesInfo?.roles || [])
          .filter((e) => (storage_userType == 3 ? e.client : !e.client))
          .map((role) => (
            <MenuItem
              onClick={() => {
                props.rolesInfo.setCurrentRole(role);
              }}
              key={role.id}
            >
              {role.name}
            </MenuItem>
          ))}
      </Menu>

      <Menu
        anchorEl={popoverAnchor}
        open={Boolean(popoverAnchor)}
        onClose={handlePopoverDesignationClosed}
        onClick={handlePopoverDesignationClosed}
        TransitionProps={{ timeout: 120 }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "hidden",
              backdropFilter: "blur(24px)",
              backgroundColor: "rgba(255,255,255,0.70)",
              border: "1px solid rgba(186,230,253,0.40)",
              borderRadius: "12px",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
              mt: 1.5,
              minWidth: "224px",
              "& .MuiMenuItem-root": {
                padding: "10px 16px",
                borderBottom: "1px solid rgba(203,213,225,0.20)",
              },
              "& .MuiMenuItem-root:last-of-type": {
                borderBottom: "none",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "rgba(14,165,233,0.08)",
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 14,
                width: 10,
                height: 10,
                bgcolor: "rgba(255,255,255,0.70)",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
                borderTop: "1px solid rgba(186,230,253,0.40)",
                borderLeft: "1px solid rgba(186,230,253,0.40)",
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {userDesignation
          .filter((d) => designation.includes(String(d.id)))
          .map((el) => (
            <MenuItem
              onClick={() => handleDesignationSelect(el.id)}
              key={el.id}
            >
              {el.name}
            </MenuItem>
          ))}
      </Menu>

      {isSymbolModalOpen && <SymbolCopyModal onClose={closeSymbolModal} />}

      <DucserialModal
        open={searchModalOpen}
        onClose={handleCloseSearch}
        searchTerm={searchTerm}
        showSearchInput={false}
      />
    </>
  );
}
